/** 小程序身份字典 member_app_role，处置端固定为地磅员 */
export const APP_ROLE_DISPOSAL = 5
